import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a9a71b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-1 mr-1" }
const _hoisted_2 = { class: "collection-header is-flex is-justify-content-space-between is-align-items-center px-3" }
const _hoisted_3 = { class: "has-text-weight-semibold" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "icon is-small"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "icon is-small"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "m-2"
}
const _hoisted_11 = { class: "is-flex is-justify-content-flex-end my-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "p-3"
}
const _hoisted_15 = { class: "parts-header-row" }
const _hoisted_16 = {
  key: 0,
  class: "part-cell",
  style: {"width":"48px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "part-cell",
  style: {"width":"56px"}
}, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "price-header"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "no-results-row"
}
const _hoisted_23 = {
  key: 0,
  class: "part-cell thumbnail-cell",
  style: {"width":"48px"}
}
const _hoisted_24 = {
  key: 0,
  class: "is-flex is-align-items-center is-justify-content-center"
}
const _hoisted_25 = { class: "image is-32x32 is-flex is-align-items-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "image is-32x32 part-thumbnail"
}
const _hoisted_28 = {
  class: "part-cell",
  style: {"width":"56px"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon base",
  style: {"max-width":"3rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-medium" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cart-plus fa-lg" })
  ])
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = {
  key: 0,
  class: "no-results-row"
}
const _hoisted_40 = {
  key: 0,
  class: "part-cell thumbnail-cell",
  style: {"width":"48px"}
}
const _hoisted_41 = {
  class: "part-cell",
  style: {"width":"56px"}
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon base",
  style: {"max-width":"3rem"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon is-medium" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cart-plus fa-lg" })
  ])
], -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 4 }

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch
} from 'vue'
import { useStore } from 'vuex'
import MeasuredVirtualList from '@/components/common/MeasuredVirtualList.vue'
import PartCollectionThumbnail from './PartCollectionThumbnail.vue'
import { useMeasuredVirtualList } from '@/composables/useMeasuredVirtualList'
import { useInfoLandingPage } from '@/components/widgets/composables/useInfoLandingPage'
import type {
  DisplayCollection,
  PartRow
} from '@/interfaces/library/partCollection'
import { getColumnTr } from '@/helpers/part'

// --------------------------------------------------
// Props / emits / composables
// --------------------------------------------------

const thumbnailColumnWidth = 48
const cartColumnWidth = 56
const defaultColumnWidth = 120
const estimatedPartRowHeight = 40
const partsListMaxHeight = 500
const virtualListOverscanPx = 400
const mobileBreakpointPx = 768


export default /*#__PURE__*/_defineComponent({
  __name: 'PartCollectionBlock',
  props: {
    canAddAllToCart: { type: Boolean },
    collection: {},
    columnWidths: {},
    contentWidth: {},
    expanded: { type: Boolean },
    hasHidePrice: { type: Boolean },
    hideThumbnail: { type: Boolean, default: false },
    isExpandingAll: { type: Boolean },
    isSearching: { type: Boolean },
    isSearchMode: { type: Boolean },
    isWidget: { type: Boolean, default: false },
    partColumns: {}
  },
  emits: ["toggle", "addToCart", "addAllToCart", "exportParts", "toggleShowRetailPrice", "toggleShowWholesalePrice", "toggleShowDiscountPrice", "previewThumbnail"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const isWidget = computed(() => store.state.auth.isWidget)
const { openPartInfoPage: openWidgetPartInfo, hasInfoLandingPage } = useInfoLandingPage()

// --------------------------------------------------
// Constants
// --------------------------------------------------

const pricingColumns = new Set([
  'retailPrice',
  'wholesalePrice',
  'discountPrice'
])

// --------------------------------------------------
// Responsive mode
// --------------------------------------------------

const isMobileView = ref(false)

function syncIsMobileView() {
  isMobileView.value = window.matchMedia(`(max-width: ${mobileBreakpointPx}px)`).matches
}

onMounted(() => {
  syncIsMobileView()
  window.addEventListener('resize', syncIsMobileView)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', syncIsMobileView)
})

// --------------------------------------------------
// Layout
// --------------------------------------------------

const partsWrapperStyle = computed(() => {
  if (isMobileView.value) return undefined

  return {
    maxHeight: `${partsListMaxHeight}px`
  }
})

const totalRowWidth = computed(() => {
  const thumbnailWidth = props.hideThumbnail ? 0 : thumbnailColumnWidth
  const columnsWidth = props.partColumns.reduce(
    (sum, column) => {
      if (pricingColumns.has(column) && !getShowPrice(column)) return sum + 32
      return sum + (props.columnWidths[column] ?? defaultColumnWidth)
    },
    0
  )

  return thumbnailWidth + cartColumnWidth + columnsWidth
})

// --------------------------------------------------
// Parts virtualization
// --------------------------------------------------

const partsWrapper = ref<HTMLElement | null>(null)

const {
  totalHeight: totalPartsHeight,
  offsetTop: partsOffsetTop,
  renderedItems: renderedParts,
  syncViewportHeight: syncPartsViewport,
  onScroll: onPartsScroll,
  setItemElement: setPartElement,
} = useMeasuredVirtualList<PartRow>({
  items: computed(() => props.collection.parts),
  scrollRef: partsWrapper,
  getItemId: part => part.id,
  estimatedItemHeight: () => estimatedPartRowHeight,
  overscanPx: virtualListOverscanPx,
})

watch(partsWrapper, el => {
  if (el) nextTick(() => syncPartsViewport())
})

watch(isMobileView, () => {
  if (!isMobileView.value) nextTick(() => syncPartsViewport())
})

// --------------------------------------------------
// Row display
// --------------------------------------------------

const partIndexMap = computed(() => {
  const map = new Map<number, number>()
  props.collection.parts.forEach((part, index) => map.set(part.id, index))
  return map
})

function isAltRow(partId: number): boolean {
  return ((partIndexMap.value.get(partId) ?? 0) % 2) !== 0
}

// --------------------------------------------------
// Drag scroll
// --------------------------------------------------

let isDragging = false
let startX = 0
let scrollLeft = 0

function onMouseDown(event: MouseEvent) {
  const target = event.currentTarget as HTMLElement
  const clickedElement = event.target as HTMLElement

  // Don't enable drag if clicking on text elements (spans/labels) or links
  if (clickedElement.tagName === 'SPAN' ||
      clickedElement.tagName === 'LABEL' ||
      clickedElement.tagName === 'A' ||
      clickedElement.tagName === 'BUTTON' ||
      clickedElement.closest('a, button')) {
    return // Allow text selection and link interaction
  }

  isDragging = true
  startX = event.pageX - target.offsetLeft
  scrollLeft = target.scrollLeft

  target.style.cursor = 'grabbing'
  target.style.userSelect = 'none'
}

function onMouseMove(event: MouseEvent) {
  if (!isDragging) return

  const target = event.currentTarget as HTMLElement
  const x = event.pageX - target.offsetLeft
  const walk = x - startX

  target.scrollLeft = scrollLeft - walk
}

function onMouseUp(event: MouseEvent) {
  const target = event.currentTarget as HTMLElement

  isDragging = false
  target.style.cursor = 'grab'
  target.style.userSelect = ''
}

// --------------------------------------------------
// Pricing
// --------------------------------------------------

const hasHidePriceDisabled = computed(() => store.getters['user/hasHidePriceDisabled'])

function isPriceLocked(): boolean {
  return !props.hasHidePrice || hasHidePriceDisabled.value
}

function getColumnStyle(column: string): object {
  if (pricingColumns.has(column) && !getShowPrice(column)) {
    return { width: '32px', minWidth: '32px', maxWidth: '32px', flexGrow: '0' }
  }
  return props.columnWidths[column] != null ? { width: `${props.columnWidths[column]}px` } : {}
}

function getShowPrice(column: string) {
  switch (column) {
    case 'retailPrice':
      return props.collection.showRetail
    case 'wholesalePrice':
      return props.collection.showWholesale
    case 'discountPrice':
      return props.collection.showDiscount
    default:
      return true
  }
}

function isZero(part: PartRow, column: string) {
  switch (column) {
    case 'retailPrice':
      return part.retailAmount === 0
    case 'wholesalePrice':
      return part.wholesaleAmount === 0
    case 'discountPrice':
      return part.discountAmount === 0
    default:
      return false
  }
}

function handleClickHidePrice(column: string) {
  switch (column) {
    case 'retailPrice':
      emit('toggleShowRetailPrice')
      break
    case 'wholesalePrice':
      emit('toggleShowWholesalePrice')
      break
    case 'discountPrice':
      emit('toggleShowDiscountPrice')
      break
  }
}

// --------------------------------------------------
// Part cell display / navigation
// --------------------------------------------------

function isPartLinkColumn(column: string) {
  const links = new Set(['partNumber', 'name'])
  return links.has(column)
}

function getPartHref(part: PartRow) {
  return {
    path: `/part/${part.id}/details`
  }
}

function getTagValues(part: PartRow, column: string) {
  return part.tags?.[column.slice(4)]?.join(', ')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.collection.name), 1),
      _createElementVNode("button", {
        disabled: _ctx.isSearchMode,
        type: "button",
        class: "button collection-toggle-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
      }, [
        (_ctx.collection.partsLoading || _ctx.isExpandingAll || _ctx.isSearching)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.expanded ? 'fas fa-minus' : 'fas fa-plus')
              }, null, 2)
            ]))
      ], 8, _hoisted_4)
    ]),
    (_ctx.expanded)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          (!!_ctx.collection.description)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(_ctx.collection.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_11, [
            (_ctx.canAddAllToCart)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: _ctx.isSearchMode,
                  class: "button mr-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addAllToCart', _ctx.collection.parts)))
                }, _toDisplayString(_ctx.$t('addAllPartsCart')), 9, _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              disabled: _ctx.isSearchMode,
              class: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('exportParts', _ctx.collection.id)))
            }, _toDisplayString(_ctx.$t('exportPartsXlsx')), 9, _hoisted_13)
          ]),
          (_ctx.collection.partsLoading || _ctx.isExpandingAll || _ctx.isSearching)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('loading')), 1))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                ref_key: "partsWrapper",
                ref: partsWrapper,
                class: "parts-list-wrapper drag-scroll pb-viewport-sm",
                style: _normalizeStyle(partsWrapperStyle.value),
                onMousedown: onMouseDown,
                onMousemove: onMouseMove,
                onMouseup: onMouseUp,
                onMouseleave: onMouseUp,
                onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onPartsScroll) && _unref(onPartsScroll)(...args)))
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle({ minWidth: `${totalRowWidth.value}px` })
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (!_ctx.hideThumbnail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                      : _createCommentVNode("", true),
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partColumns, (column) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "part-cell",
                        key: column,
                        style: _normalizeStyle(getColumnStyle(column))
                      }, [
                        (_unref(pricingColumns).has(column))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (getShowPrice(column))
                                ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(_unref(getColumnTr)(column)), 1))
                                : _createCommentVNode("", true),
                              (!isPriceLocked())
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "icon is-small has-text-link eye-icon",
                                    onClick: ($event: any) => (handleClickHidePrice(column))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(getShowPrice(column) ? 'fa fa-eye-slash' : 'fa fa-eye')
                                    }, null, 2)
                                  ], 8, _hoisted_20))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(getColumnTr)(column)), 1))
                      ], 4))
                    }), 128))
                  ]),
                  (isMobileView.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_ctx.collection.parts.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('noResults')), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collection.parts, (part) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: part.id,
                            class: _normalizeClass(["part-row", { 'part-row--alt': isAltRow(part.id) }])
                          }, [
                            (!_ctx.hideThumbnail)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (part.thumbnailUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                        _createElementVNode("figure", _hoisted_25, [
                                          _createElementVNode("img", {
                                            src: part.thumbnailUrl
                                          }, null, 8, _hoisted_26)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("figure", _hoisted_27))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_28, [
                              (part.isOrderable)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    "data-unit": "part-collection-add-to-cart-button",
                                    onClick: ($event: any) => (_ctx.$emit('addToCart', part))
                                  }, _hoisted_31, 8, _hoisted_29))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partColumns, (column) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "part-cell",
                                key: `${part.id}-${column}`,
                                style: _normalizeStyle(getColumnStyle(column))
                              }, [
                                (isPartLinkColumn(column))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (isWidget.value)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass({ 'has-text-link': _unref(hasInfoLandingPage), 'pointer-on-hover': _unref(hasInfoLandingPage) }),
                                            onClick: ($event: any) => (_unref(openWidgetPartInfo)(part))
                                          }, _toDisplayString(part[column]), 11, _hoisted_32))
                                        : (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            to: getPartHref(part)
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(part[column]), 1)
                                            ], undefined, true),
                                            _: 2
                                          }, 1032, ["to"]))
                                    ], 64))
                                  : (column === 'quantity')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(part.quantity) + " " + _toDisplayString(part.uom), 1))
                                    : (column.startsWith('tag:'))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(getTagValues(part, column)), 1))
                                      : (_unref(pricingColumns).has(column))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                            (!getShowPrice(column))
                                              ? (_openBlock(), _createElementBlock("label", _hoisted_35))
                                              : (isZero(part, column))
                                                ? (_openBlock(), _createElementBlock("label", _hoisted_36, _toDisplayString(_ctx.$t('noPrice')), 1))
                                                : (_openBlock(), _createElementBlock("label", _hoisted_37, _toDisplayString(part[column]), 1))
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(part[column]), 1))
                              ], 4))
                            }), 128))
                          ], 2))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(MeasuredVirtualList, {
                        key: 1,
                        "total-height": _unref(totalPartsHeight),
                        "offset-top": _unref(partsOffsetTop)
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.collection.parts.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.$t('noResults')), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderedParts), (part) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: part.id,
                              ref_for: true,
                              ref: el => _unref(setPartElement)(part.id, el as Element | null),
                              class: _normalizeClass(["part-row", { 'part-row--alt': isAltRow(part.id) }])
                            }, [
                              (!_ctx.hideThumbnail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createVNode(PartCollectionThumbnail, {
                                      "is-widget": isWidget.value,
                                      "thumbnail-url": part.thumbnailUrl,
                                      onPreview: ($event: any) => (emit('previewThumbnail', part))
                                    }, null, 8, ["is-widget", "thumbnail-url", "onPreview"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_41, [
                                (part.isOrderable)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      "data-unit": "part-collection-add-to-cart-button",
                                      onClick: ($event: any) => (_ctx.$emit('addToCart', part))
                                    }, _hoisted_44, 8, _hoisted_42))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partColumns, (column) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "part-cell",
                                  key: `${part.id}-${column}`,
                                  style: _normalizeStyle(getColumnStyle(column))
                                }, [
                                  (isPartLinkColumn(column))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (isWidget.value)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass({ 'has-text-link': _unref(hasInfoLandingPage), 'pointer-on-hover': _unref(hasInfoLandingPage) }),
                                              onClick: ($event: any) => (_unref(openWidgetPartInfo)(part))
                                            }, _toDisplayString(part[column]), 11, _hoisted_45))
                                          : (_openBlock(), _createBlock(_component_router_link, {
                                              key: 1,
                                              to: getPartHref(part)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(part[column]), 1)
                                              ], undefined, true),
                                              _: 2
                                            }, 1032, ["to"]))
                                      ], 64))
                                    : (column === 'quantity')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(part.quantity) + " " + _toDisplayString(part.uom), 1))
                                      : (column.startsWith('tag:'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(getTagValues(part, column)), 1))
                                        : (_unref(pricingColumns).has(column))
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              (!getShowPrice(column))
                                                ? (_openBlock(), _createElementBlock("label", _hoisted_48))
                                                : (isZero(part, column))
                                                  ? (_openBlock(), _createElementBlock("label", _hoisted_49, _toDisplayString(_ctx.$t('noPrice')), 1))
                                                  : (_openBlock(), _createElementBlock("label", _hoisted_50, _toDisplayString(part[column]), 1))
                                            ], 64))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(part[column]), 1))
                                ], 4))
                              }), 128))
                            ], 2))
                          }), 128))
                        ], undefined, true),
                        _: 1
                      }, 8, ["total-height", "offset-top"]))
                ], 4)
              ], 36))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})